import axios from "axios";
import config from "@/config/constants";
import store from "../store";

/**
 * Get coaching data for the current user
 * @returns {Promise<{hasCoach: boolean, coach: object|null, closedJourney: boolean}>}
 */
export async function getCoachingData() {
  try {
    const payload = {
      user_id: store.getters.user_id,
    };

    const res = await axios.post(
      config.api_env + "/application/api/u/coaching/get-data",
      payload,
      config.options
    );

    if (res.data.success) {
      return {
        hasCoach: res.data.coach && !res.data.closed_journey,
        coach: res.data.coach || null,
        closedJourney: res.data.closed_journey || false
      };
    } else if (res.data.err && res.data.err.includes("3994")) {
      store.dispatch("logout");
      return {
        hasCoach: false,
        coach: null,
        closedJourney: false
      };
    }

    return {
      hasCoach: false,
      coach: null,
      closedJourney: false
    };
  } catch (error) {
    console.error('Error fetching coaching data:', error);
    return {
      hasCoach: false,
      coach: null,
      closedJourney: false
    };
  }
}
